import React from 'react';
import { createSignPayloadMessage } from '../components/SignPayloadDialog/helpers/createSignPayloadMessage';
import { useWeb3 } from '../../../../../hooks/useWeb3';
import { createSignMultiCallMessage } from '../components/SignPayloadDialog/helpers/createSignMultiCallMessage';
import useSingleCallSign from './useSingleCallSign';
import { EIP712TypedData } from '../../../../../utils/web3Provider';

interface SignMultiCallTypedData {
  rowData: any;
  rawTx: any;
  isTron: boolean;
  chainId: number;
  fromAddress: string;
}

interface IProps {
  signTypedDataWithWrappedPayload: (typedData: EIP712TypedData) => Promise<string>;
}

const useMultiCallSign = (props: IProps) => {
  const { signTypedDataWithWrappedPayload } = props;

  const signMultiCallTypedData = async (props: SignMultiCallTypedData) => {
    const { rowData, rawTx, isTron, chainId, fromAddress } = props;

    const signPayloadMessage = createSignMultiCallMessage({
      rowData,
      rawTx,
      isTron,
    });

    const types = {
      Multicall: [
        {
          name: 'from',
          type: 'address',
        },
        {
          name: 'multicallTxs',
          type: 'MulticallTx[]',
        },
        {
          name: 'nonce',
          type: 'uint256',
        },
        {
          name: 'batchId',
          type: 'uint256',
        },
        {
          name: 'requireSuccess',
          type: 'bool',
        },
      ],
      MulticallTx: [
        {
          name: 'to',
          type: 'address',
        },
        {
          name: 'value',
          type: 'uint256',
        },
        {
          name: 'data',
          type: 'bytes',
        },
      ],
    };

    const domain = {
      name: 'MultiSigAccount',
      version: '1.0',
      chainId: chainId,
      verifyingContract: fromAddress,
    };

    const signature = await signTypedDataWithWrappedPayload({
      types,
      primaryType: 'Multicall',
      domain,
      message: signPayloadMessage,
    });

    return signature;
  };

  return { signMultiCallTypedData };
};

export default useMultiCallSign;
